import { Typography, Card, Row, Col, Tag } from "antd";
import {
  LineChartOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export default function OverviewCenter() {
  const features = [
    {
      icon: <ThunderboltOutlined style={{ fontSize: 32, color: "#1890ff" }} />,
      title: "AI 预测分销",
      desc: "基于智能算法的销量与需求预测，辅助备货与排产决策，提升供应链效率。",
    },
    {
      icon: <LineChartOutlined style={{ fontSize: 32, color: "#52c41a" }} />,
      title: "可视化报表",
      desc: "多维度图表与看板，实时展示业务数据，让数据一目了然，支持快速洞察与决策。",
    },
    {
      icon: <AppstoreOutlined style={{ fontSize: 32, color: "#722ed1" }} />,
      title: "企业模块展示",
      desc: "业务模块与企业数字化能力以卡片形式集中展示，便于快速进入各子系统。",
    },
    {
      icon: <BarChartOutlined style={{ fontSize: 32, color: "#fa8c16" }} />,
      title: "数据驱动",
      desc: "帮助用户更快了解数据、熟悉公司流程，从数据到流程形成闭环管理。",
    },
  ];

  return (
    <div style={{ maxWidth: 960, margin: "0 auto" }}>
      <div className="tech-hero-gradient" style={{ marginBottom: 32, padding: 28 }}>
        <Title level={2} className="tech-page-title" style={{ marginBottom: 12, fontSize: 26 }}>
          智能报表中心 · 概览
        </Title>
        <Paragraph type="secondary" style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
          本平台面向 AI 预测分销、可视化报表与企业模块展示等需求，帮助您更快地了解数据、熟悉公司流程，
          实现数据驱动决策与流程透明化。
        </Paragraph>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <Tag color="blue">AI 预测</Tag>
          <Tag color="green">可视化</Tag>
          <Tag color="purple">企业模块</Tag>
        </div>
      </div>

      <Row gutter={[24, 24]}>
        {features.map((item, i) => (
          <Col xs={24} sm={12} key={i}>
            <Card
              size="small"
              hoverable
              className="tech-card"
              style={{ height: "100%", borderRadius: 12 }}
              bodyStyle={{ padding: 20 }}
            >
              <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
                <span className="tech-icon-wrap">{item.icon}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Title level={5} style={{ marginBottom: 8, fontWeight: 600 }}>
                    {item.title}
                  </Title>
                  <Text type="secondary">{item.desc}</Text>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Card className="tech-card" style={{ marginTop: 28, borderRadius: 12 }} bodyStyle={{ padding: 24 }}>
        <Title level={5} style={{ marginBottom: 12, fontWeight: 600 }}>
          使用指引
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          <strong>概览中心</strong>：了解平台能力与定位。<br />
          <strong>业务模块</strong>：进入 SPU 排产、物流监控、备货预测、在售商品、预测 MAPE 及各类报表。<br />
          <strong>企业数字化</strong>：查看供应链、财务、人力、数据分析与 AI、项目、协同办公、IT 运维等模块入口。
        </Paragraph>
      </Card>
    </div>
  );
}
